import { FIELD_TYPES_BY_CODE } from "../../field_types";
import { forEach } from "lodash";

export default function (field) {
  return function (item) {
    if (!field || !item) {
      return null;
    }

    const val = item[field.code];

    if (!val || (val && val.__visible === false)) {
      return null; // There is no Values to check as they are hidden.
    }

    var results = {};
    var hasErrors = false;
    forEach(field.fields, function (f) {
      const FieldType = FIELD_TYPES_BY_CODE[f.field_type];

      if (FieldType) {
        const validator = FieldType.validator(f);

        var result = validator(val);
        if (result != null) {
          results[f.code] = result;
          hasErrors = true; // we have at least 1 error in the Section
        }
      }
    });

    if (hasErrors) {
      return results;
    }
    return null;
  };
}
